import React, {useEffect, useState} from "react"
import Field from "./Field"
import Label from "../widgets/Label";
import Select from "../widgets/Select";
import {DefaultButton, AlternativeButton} from "../widgets/Buttons";
import {formatDate} from "../utils";



const typesVasculites = [
  {category: "Gros vaisseaux",
   types: [
     {
       name: "Takayasu"
     },
     {
       name: "Artérite à cellules géantes / artérite temporale"
     },
     {
       name: "Autre"
     }
   ]},
  {category: "Moyens vaisseaux",
   types: [
     {
       name: "Polyartérite noueuse (PAN)"
     },
     {
       name: "Kawasaki"
     },
     {
       name: "Autre"
     }
   ]},
  {category: "Petits vaisseaux / ANCA",
   types: [
     {
       name: "Granulomatose avec polyangiite (GPA / Wegener)"
     },
     {
       name: "Polyartérite microscopique (PAM)"
     },
     {
       name: "Granulomatose éosinophilique avec polyangiite (GEPA)"
     }
   ]},
  {category: "Petits vaisseaux / complexes immuns",
   types: [
     {
       name: "Anti GBM (Goodpasture)"
     },
     {
       name: "Vasculite cryoglobulinémique"
     },
     {
       name: "Vasculite à IgA (purpura de Henoch Schonlein)"
     },
     {
       name: "Vasculite urticarienne hypocomplémentémique (vasculite anti C1q)"
     },
     {
       name: "Autre (Petits vaisseaux / complexes immuns)", needsAdditionalSpecs: true
     }
   ]},
  {category: "Taille variable",
   types: [
     {
       name: "Behcet"
     },
     {
       name: "Cogan"
     },
     {
       name: "Autre"
     }
   ]},
  {category: "Vasculite isolée à un organe",
   types: [
     {
       name: "Vasculite cutanée"
     },
     {
       name: "Vasculite isolée du système nerveux central"
     },
     {
       name: "Aortite isolée"
     },
     {
       name: "Autre (Vasculite isolée à un organe)", needsAdditionalSpecs: true
     }
   ]},
  {category: "vasculite associée à une maladie systémique",
   types: [
     {
       name: "lupus érythémateux disséminé"
     },
     {
       name: "arthrite rhumatoïde"
     },
     {
       name: "sarcoïdose"
     },
     {
       name: "Autre (vasculite associée à une maladie systémique)", needsAdditionalSpecs: false
     }
   ]},
  {category: "Vasculite associée à une étiologie probable",
   types: [
     {
       name: "hépatite C"
     },
     {
       name: "hépatite B"
     },
     {
       name: "syphilis"
     },
     {
       name: "autre infection"
     },
     {
       name: "médicaments / drogues"
     },
     {
       name: "vasculite à ANCA associée à médicaments ou drogues"
     },
     {
       name: "néoplasie"
     },
     {
       name: "Autre (Vasculite associée à une étiologie probable)", needsAdditionalSpecs: true
     }
   ]}
]


export const VasculiteForm = ({
    dossier,
    mode,
    onSave,
    setEditing,
    onCancel,
    currentRound,
    showVisitDateField
}) => {


    const [gender, setGender] = useState(dossier.gender)

    const [genderIsNull, setGenderIsNull] = useState(!dossier.gender)

    const [symptoms_start_date, set_symptoms_start_date] = useState(dossier.symptoms_start_date)

    const [symptoms_start_date_msg, set_symptoms_start_date_msg] = useState(null)

    const [diagnosis_date, set_diagnosis_date] = useState(dossier.diagnosis_date)

    const [diagnosis_date_msg, set_diagnosis_date_msg] = useState(null)

    const [vasculite_type, set_vasculite_type] = useState(dossier.vasculite_type)

    const [vasculite_subtype, set_vasculite_subtype] = useState(dossier.vasculite_type)

    const [year_of_birth, set_year_of_birth] = useState(dossier.year_of_birth)

    const [year_of_birth_error_msg, set_year_of_birth_error_msg] = useState()

    const [notes, set_notes] = useState(dossier.notes || '')

    const [vasculite_subtype_options, set_vasculite_subtype_options] = useState([])

    const [visit_date, set_visit_date] = useState(
        showVisitDateField ?
            currentRound ? currentRound.visit_date : null
            : null
    )

    const [visit_date_msg, set_visit_date_msg] = useState(null)

    const isEditMode = mode === 'create' || mode === 'edit'


    useEffect(() => {

        if(gender === "" || (!gender)) {
            setGenderIsNull(true)
        }
        else {
            setGenderIsNull(false)
        }

    },[gender])

    useEffect(() => {
        if(year_of_birth > 1900 && year_of_birth < 2050) {
            set_year_of_birth_error_msg(null)
        }
        else {
            set_year_of_birth_error_msg("date non valide")
        }

    }, [year_of_birth + ""])

    useEffect(() => {

        const ssd = formatDate(symptoms_start_date)
        const dv = formatDate(visit_date)

        if(ssd > dv) {
            set_symptoms_start_date_msg("doit précéder la date de visite")
        }
        else {
            if(ssd) {
                set_symptoms_start_date_msg(null)
            }
        }

    }, [`${symptoms_start_date}`]);

    useEffect(() => {

        let errorMsg = null

        const dd = diagnosis_date
        const dv = visit_date

        if(dv < dd) {
            errorMsg = "ne peut précéder le diagnostic"
        }

        const now = formatDate(new Date())

        if(visit_date > now) {
            errorMsg = "ne peut être une date future"
        }

        set_visit_date_msg(errorMsg)

    }, [`${visit_date} ${diagnosis_date}`]);

    useEffect(() => {

        const vasculite_subtypes = typesVasculites.find(o => o.category === vasculite_type)

        set_vasculite_subtype_options(vasculite_subtypes && vasculite_subtypes.types)
        if(vasculite_subtypes && vasculite_subtypes.types) {
            set_vasculite_subtype(vasculite_subtypes.types[0])
        }

    }, [vasculite_type])

    useEffect(() => {

        const dd = formatDate(diagnosis_date)

        if(!dd) {
            set_diagnosis_date_msg(null)
            return
        }

        const ds = formatDate(symptoms_start_date)

        if(ds > dd) {
            set_diagnosis_date_msg("ne peut précéder début des symptomes")
        }
        else {
            set_diagnosis_date_msg(null)
        }

    },[`${diagnosis_date}, ${symptoms_start_date}`])

    const edit = () => setEditing(true)

    const extractDossierFields = () => ({
        id: dossier.id,
        gender,
        year_of_birth,
        vasculite_type,
        vasculite_subtype: vasculite_subtype ? vasculite_subtype.name : null,
        notes,
        symptoms_start_date,
        diagnosis_date,
        visit_date
    })

    const footer = <>
        <DefaultButton
            caption={"Sauvegarder"}
            onClick={() => {


                if(showVisitDateField) {
                    if(!visit_date) {
                        set_visit_date_msg("svp saisir la date de visite")
                    }
                }

                if(!symptoms_start_date){
                    set_symptoms_start_date_msg("svp saisir la date de début de symptome")
                }

                if(!diagnosis_date) {
                    set_diagnosis_date_msg("svp saisir la date de début des symptomes")
                }

                if(showVisitDateField) {
                    if(! visit_date || ! symptoms_start_date || ! diagnosis_date) {
                        return
                    }
                }
                else {
                    if(! symptoms_start_date || ! diagnosis_date) {
                        return
                    }
                }

                if(genderIsNull) {
                    return
                }

                if(year_of_birth_error_msg) {
                    return
                }
                const ex = extractDossierFields()
                console.log(ex)
                onSave(ex)
            }}
        />
        <AlternativeButton
            caption={"Annuler"}
            onClick={onCancel}
        />
    </>


    const popEditPanel = () => <div className="grid grid-cols-4 gap-6">
        <div>
            <Label text={"Sexe"}/>
            <
                Select
                value={gender || ''}
                onChange={e =>
                    setGender(e.target.value)
                }
            >
                <option value={""}>choisir</option>
                <option key={"M"} value={"M"}>Homme</option>
                <option key={"F"} value={"F"}>Femme</option>
            </Select>
            {genderIsNull && <p className="mt-2 text-sm text-red-600 dark:text-red-500">SVP choisir</p>}
        </div>
        <Field
            fieldValues={{year_of_birth}}
            isEditMode={true}
            errorMessage={year_of_birth_error_msg}
            onFieldEdit={(name, value) => {
                set_year_of_birth(value)
            }}
            adata={{
                fieldName: 'year_of_birth',
                label: 'année de naissance',
                type: "nombre"
            }}
        />
        <Field
            errorMessage={symptoms_start_date_msg}
            fieldValues={{symptoms_start_date}}
            isEditMode={true}
            onFieldEdit={(name, value) => {
                set_symptoms_start_date(value)
            }}
            adata={{
                fieldName: 'symptoms_start_date',
                label: 'début des symptomes',
                type: "date"
            }}
        />
        <Field
            errorMessage={diagnosis_date_msg}
            fieldValues={{diagnosis_date}}
            isEditMode={true}
            onFieldEdit={(name, value) => {
                set_diagnosis_date(value)
            }}
            adata={{
                fieldName: 'diagnosis_date',
                label: 'date du diagnostique',
                type: "date"
            }}
        />
        <div>
            <Label text={"Type de Vasculite"}/>
            <
                Select
                value={vasculite_type || ''}
                onChange={e => {

                    set_vasculite_type(e.target.value)
                }}
            >
                <option value={null}>choisir</option>
                {
                    typesVasculites.map(
                        t =>
                            <option key={t.category} value={t.category}>{t.category}</option>
                    )
                }
            </Select>
        </div>
        <div>
            <Label text={"Détails"}/>
            <
                Select
                value={vasculite_subtype || ''}
                onChange={e => set_vasculite_subtype(e.target.value)}
            >
                {
                    vasculite_subtype_options &&
                    vasculite_subtype_options.map(
                        t =>
                            <option key={t.name} value={t.name}>{t.name}</option>
                    )
                }
            </Select>
        </div>
        <Field
            fieldValues={{notes}}
            onFieldEdit={(name, value) => {
                set_notes(value)
            }}
            isEditMode={true}
            adata={{
                fieldName: 'notes',
                label: 'Notes',
                type: "text"
            }}
        />
        {
            showVisitDateField && <Field
                errorMessage={visit_date_msg}
                fieldValues={{visit_date}}
                 onFieldEdit={(name, value) => {
                    set_visit_date(value)
                }}
                adata={{
                    fieldName: 'visit_date',
                    label: 'date de la dernière visite',
                    type: "date"
                }}
            />
        }
    </div>

    return <div>{popEditPanel()}{footer}</div>
}